import { render } from "./main_warehouses.vue?vue&type=template&id=16fc76d4&scoped=true"
import script from "./main_warehouses.vue?vue&type=script&lang=js"
export * from "./main_warehouses.vue?vue&type=script&lang=js"

import "./main_warehouses.vue?vue&type=style&index=0&id=16fc76d4&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fc76d4"]])

export default __exports__